<div class="weaveGrid loaderContainer ">
  <div class="weaveLoader">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve">
      <style type="text/css">
        .st0{display:none;}
        .st1{display:inline;}
        .st2{fill:#26D07C;}
        .st3{fill:#E68699;}
        .st4{fill:#307FE2;}
        .st5{fill:#59CBE8;}
        .st6{clip-path:url(#SVGID_2_);}
        .st7{opacity:0.3;clip-path:url(#SVGID_6_);}
        .st8{fill:none;}
        .st9{clip-path:url(#SVGID_10_);}
        .st10{clip-path:url(#SVGID_14_);}
        .st11{clip-path:url(#SVGID_18_);}
        .st12{opacity:0.3;clip-path:url(#SVGID_22_);}
        .st13{opacity:0.25;clip-path:url(#SVGID_26_);}
        .st14{opacity:0.25;clip-path:url(#SVGID_30_);}
        .st15{fill:none;stroke:#E68699;stroke-width:30;stroke-miterlimit:10;}
        .st16{fill:none;stroke:#26D07C;stroke-width:30;stroke-miterlimit:10;}
        .st17{fill:none;stroke:#59CBE8;stroke-width:30;stroke-miterlimit:10;}
        .st18{fill:none;stroke:#307FE2;stroke-width:30;stroke-miterlimit:10;}
      </style>
    <g id="Layer_1" class="st0">
	<g class="st1">
		<g>
			<path class="st2" d="M492.6,225.53l-22.37-22.37L571.4,101.98c14.56-14.58,14.56-38.28,0-52.84c-14.56-14.58-38.27-14.58-52.84,0
				l-25.94,25.94L470.25,52.7l11.78-11.8l14.16-14.16c17.28-17.28,41.4-23.47,63.61-18.61c2.17,0.48,4.3,1.05,6.41,1.73
				c0.53,0.18,1.07,0.35,1.6,0.53c2.1,0.75,4.18,1.58,6.23,2.53c1.02,0.48,2.03,0.98,3.03,1.5c1.5,0.8,2.98,1.65,4.43,2.55
				c0.55,0.35,1.08,0.68,1.63,1.05c0.93,0.63,1.87,1.28,2.78,1.95c1.38,1.02,2.72,2.08,4.03,3.22c1.32,1.13,2.58,2.33,3.83,3.56
				c8,8,13.63,17.46,16.88,27.54c0.12,0.37,0.23,0.73,0.35,1.12c0.53,1.77,1,3.55,1.4,5.35c2.13,9.75,2.13,19.88,0,29.6
				c-0.25,1.08-0.5,2.17-0.78,3.23c-0.3,1.07-0.6,2.13-0.95,3.2c-0.18,0.53-0.35,1.05-0.53,1.58c-0.38,1.05-0.77,2.1-1.18,3.15
				c-0.43,1.03-0.87,2.07-1.35,3.08c-0.48,1.02-0.98,2.03-1.5,3.03c-0.78,1.5-1.65,2.98-2.55,4.43c-0.33,0.55-0.7,1.08-1.05,1.63
				c-2.18,3.3-4.7,6.43-7.51,9.4c-0.4,0.42-0.8,0.83-1.22,1.25L492.6,225.53z"/>
		</g>
    <g>
			<path class="st3" d="M395.01,127.92l-22.37,22.37l-11.78-11.78l-14.16-14.14c-26.96-26.96-26.96-70.67,0-97.61
				c0.13-0.13,0.28-0.27,0.42-0.42c1.13-1.12,2.28-2.18,3.47-3.2c1.33-1.13,2.7-2.22,4.1-3.25c0.7-0.52,1.42-1.02,2.13-1.52
				c1.42-0.95,2.87-1.87,4.35-2.72c0.73-0.42,1.48-0.83,2.23-1.23h0.02c1-0.52,2.02-1.02,3.03-1.5c2.03-0.95,4.11-1.78,6.21-2.53
				c0.53-0.17,1.07-0.35,1.6-0.53c2.12-0.68,4.26-1.25,6.43-1.73c9.86-2.15,20.12-2.13,30,0.08c1.92,0.43,3.81,0.93,5.68,1.53
				c4.91,1.57,9.68,3.67,14.21,6.35c1.47,0.87,2.9,1.78,4.31,2.77c0.47,0.33,0.95,0.68,1.42,1.03c1.4,1.02,2.75,2.1,4.08,3.23
				c0,0.02,0.02,0.02,0.02,0.02c1.33,1.15,2.62,2.35,3.88,3.6l0.02,0.02l14.14,14.16l11.78,11.78h0.02l22.37,22.37l52.84,52.84
				l-22.39,22.39l-52.84-52.84l-22.37-22.39l-25.94-25.94c-14.58-14.58-38.27-14.58-52.84,0c-14.56,14.56-14.56,38.27,0,52.84
				L395.01,127.92z"/>
		</g>
    <g>
			<path class="st4" d="M346.7,273.84c-26.96-26.95-26.96-70.65,0-97.61l14.14-14.14h0.02l11.76-11.78h0.02v-0.02l75.22-75.22
				l22.37,22.39L369.07,198.63c-14.56,14.58-14.56,38.27,0,52.84c14.58,14.56,38.27,14.56,52.84,0l25.94-25.94l22.37,22.37
				l-25.94,25.94C417.33,300.8,373.65,300.8,346.7,273.84z"/>
		</g>
    <g>
			<path class="st5" d="M530.14,292.45c-1.08-0.23-2.17-0.5-3.23-0.78c-1.07-0.3-2.13-0.62-3.2-0.95c-0.53-0.17-1.05-0.35-1.58-0.53
				c-1.77-0.63-3.53-1.32-5.26-2.1c-2.02-0.9-4-1.9-5.93-3c-1.95-1.1-3.85-2.3-5.7-3.62c-0.53-0.37-1.05-0.75-1.58-1.15
				c-1.3-0.97-2.58-2-3.82-3.08c-1.25-1.08-2.47-2.22-3.65-3.4l-14.16-14.16l-11.78-11.78h-0.02l-22.37-22.37l-52.84-52.84
				l22.37-22.37l52.84,52.84l22.37,22.37h0.02l25.94,25.94c14.58,14.56,38.28,14.56,52.84,0c14.56-14.58,14.56-38.27,0-52.84
				l-25.94-25.94l22.37-22.37l11.78,11.78l14.16,14.16c0.42,0.42,0.83,0.85,1.25,1.27c0.4,0.43,0.82,0.87,1.22,1.32
				c0.78,0.87,1.55,1.75,2.27,2.65c0.75,0.9,1.47,1.82,2.15,2.77c0.68,0.92,1.33,1.87,1.97,2.82c0,0,0.02,0,0.02,0.02
				c9.11,13.79,12.74,30.17,10.88,46.01c-0.3,2.68-0.78,5.35-1.42,8c-0.27,1.22-0.6,2.4-0.95,3.6c-0.15,0.53-0.32,1.07-0.5,1.6
				c-0.3,0.92-0.62,1.83-0.95,2.73c-0.48,1.35-1.03,2.7-1.63,4.02c-0.3,0.7-0.63,1.4-0.97,2.1c-0.17,0.33-0.32,0.67-0.5,1
				c-0.42,0.83-0.87,1.67-1.32,2.5c-3.03,5.45-6.88,10.58-11.51,15.21c-4.63,4.63-9.76,8.48-15.21,11.51
				c-0.83,0.45-1.67,0.9-2.5,1.32c-0.33,0.18-0.67,0.33-1,0.5c-0.7,0.33-1.4,0.67-2.1,0.97c-1.32,0.6-2.67,1.15-4.01,1.63
				c-0.9,0.33-1.82,0.65-2.73,0.95c-0.53,0.18-1.07,0.35-1.6,0.5c-1.2,0.35-2.38,0.68-3.6,0.95c-2.7,0.65-5.45,1.13-8.2,1.43
				C545.26,294.47,537.58,294.08,530.14,292.45z"/>
		</g>
    <g>
			<defs>
				<polygon id="SVGID_1_" points="523.06,150.33 470.23,97.48 447.84,75.11 447.84,75.09 436.06,63.32 458.44,40.94 470.22,52.72
					470.23,52.72 492.61,75.11 545.45,127.94 				"/>
			</defs>
      <clipPath id="SVGID_2_">
				<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
			</clipPath>
      <g class="st6">
				<g>
					<defs>
						<polygon id="SVGID_3_" points="523.06,150.34 470.23,97.49 447.84,75.12 447.84,75.1 436.06,63.32 458.44,40.95 470.22,52.73
							470.23,52.73 492.61,75.12 545.45,127.95 						"/>
					</defs>
          <clipPath id="SVGID_4_">
						<use xlink:href="#SVGID_3_"  style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_4_);">

							<image style="overflow:visible;" width="110" height="110" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAABuCAYAAADGWyb7AAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(1 0 0 1 436 40.5365)">
						</image>
					</g>
				</g>
			</g>
		</g>
    <g>
			<defs>
				<path id="SVGID_5_" d="M492.63,75.09l-22.39-22.37V52.7l11.78-11.76v-0.02l14.16-14.14c0.52-0.52,1.05-1.03,1.58-1.55
					c0.53-0.5,1.08-1,1.63-1.48l0.02-0.02c1.1-0.97,2.22-1.9,3.37-2.78c0.02,0,0.02,0,0.02,0c0.92-0.7,1.85-1.38,2.78-2.05
					c1.9-1.33,3.83-2.53,5.81-3.63c0.98-0.57,1.98-1.08,3-1.58c1.02-0.48,2.03-0.97,3.05-1.42h0.02c1.03-0.43,2.07-0.87,3.1-1.27
					c0.02,0,0.02,0,0.02,0c1.57-0.58,3.15-1.12,4.75-1.6c0,0,0,0,0.02,0c1.05-0.3,2.13-0.6,3.2-0.87h0.02
					c7.96-1.95,16.21-2.45,24.32-1.52c0.17,0.02,0.32,0.03,0.48,0.05c1.25,0.15,2.5,0.35,3.75,0.57c1.33,0.23,2.67,0.52,4,0.83
					c1.18,0.27,2.35,0.58,3.53,0.93c0.53,0.15,1.07,0.32,1.6,0.5c0.92,0.3,1.82,0.62,2.73,0.95c1.35,0.48,2.7,1.03,4.02,1.63
					c0.7,0.3,1.4,0.63,2.1,0.97c0.33,0.17,0.67,0.32,1,0.5c0.83,0.42,1.67,0.87,2.5,1.32c5.45,3.03,10.56,6.86,15.19,11.51
					L571.4,49.16c-14.56-14.56-38.27-14.56-52.83,0L492.63,75.09z"/>
			</defs>
      <clipPath id="SVGID_6_">
				<use xlink:href="#SVGID_5_"  style="overflow:visible;"/>
			</clipPath>
      <g class="st7">
				<g>
					<defs>
						<path id="SVGID_7_" d="M492.63,75.1l-22.39-22.37v-0.02l11.78-11.76v-0.02l14.16-14.14c0.52-0.52,1.05-1.03,1.58-1.55
							c0.53-0.5,1.08-1,1.63-1.48l0.02-0.02c1.1-0.97,2.22-1.9,3.37-2.78c0.02,0,0.02,0,0.02,0c0.92-0.7,1.85-1.38,2.78-2.05
							c1.9-1.33,3.83-2.53,5.81-3.63c0.98-0.57,1.98-1.08,3-1.58c1.02-0.48,2.03-0.97,3.05-1.42h0.02c1.03-0.43,2.07-0.87,3.1-1.27
							c0.02,0,0.02,0,0.02,0c1.57-0.58,3.15-1.12,4.75-1.6c0,0,0,0,0.02,0c1.05-0.3,2.13-0.6,3.2-0.87h0.02
							c7.96-1.95,16.21-2.45,24.32-1.52c0.17,0.02,0.32,0.03,0.48,0.05c1.25,0.15,2.5,0.35,3.75,0.57c1.33,0.23,2.67,0.52,4,0.83
							c1.18,0.27,2.35,0.58,3.53,0.93c0.53,0.15,1.07,0.32,1.6,0.5c0.92,0.3,1.82,0.62,2.73,0.95c1.35,0.48,2.7,1.03,4.02,1.63
							c0.7,0.3,1.4,0.63,2.1,0.97c0.33,0.17,0.67,0.32,1,0.5c0.83,0.42,1.67,0.87,2.5,1.32c5.45,3.03,10.56,6.86,15.19,11.51
							L571.4,49.16c-14.56-14.56-38.27-14.56-52.83,0L492.63,75.1z"/>
					</defs>
          <clipPath id="SVGID_8_">
						<use xlink:href="#SVGID_7_"  style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_8_);">

							<image style="overflow:visible;" width="124" height="124" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHwAAAB8CAYAAACrHtS+AAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(1 0 0 1 470 -22.4634)">
						</image>
					</g>
				</g>
			</g>
		</g>
    <g>
			<path class="st8" d="M470.23,247.93l-22.39-22.37l22.39,22.39V247.93z M346.69,273.87v0.02c1.23,1.25,2.52,2.43,3.83,3.55
				C349.2,276.3,347.92,275.1,346.69,273.87z M444.29,273.88v-0.02c-1.25,1.23-2.52,2.43-3.83,3.56
				C441.78,276.32,443.05,275.13,444.29,273.88z M366.43,287.69c2.05,0.95,4.11,1.8,6.23,2.53
				C370.54,289.48,368.48,288.64,366.43,287.69z M424.55,287.69c-2.03,0.95-4.11,1.78-6.23,2.53
				C420.44,289.49,422.52,288.64,424.55,287.69z M374.24,290.76c2.13,0.68,4.26,1.27,6.45,1.73
				C378.51,292.01,376.37,291.44,374.24,290.76z M416.74,290.76c-2.12,0.68-4.26,1.25-6.43,1.73
				C412.47,292.03,414.62,291.44,416.74,290.76z M492.62,75.1l-22.39-22.37l22.37,22.39L492.62,75.1z"/>
		</g>
    <g>
			<polyline class="st8" points="346.69,273.88 346.69,273.87 346.71,273.87 			"/>
		</g>
    <g>
			<defs>
				<polygon id="SVGID_9_" points="383.22,184.5 360.85,162.11 372.61,150.33 372.63,150.33 372.63,150.31 395,127.94
					395.02,127.94 447.84,75.11 470.23,97.48 				"/>
			</defs>
      <clipPath id="SVGID_10_">
				<use xlink:href="#SVGID_9_"  style="overflow:visible;"/>
			</clipPath>
      <g class="st9">
				<g>
					<defs>
						<polygon id="SVGID_11_" points="383.22,184.51 360.85,162.12 372.61,150.34 372.63,150.34 372.63,150.32 395,127.95
							395.02,127.95 447.84,75.12 470.23,97.49 						"/>
					</defs>
          <clipPath id="SVGID_12_">
						<use xlink:href="#SVGID_11_"  style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_12_);">

							<image style="overflow:visible;" width="111" height="110" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG8AAABuCAYAAAApmU3FAAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(1 0 0 1 360 74.5366)">
						</image>
					</g>
				</g>
			</g>
		</g>
    <g>
			<defs>
				<path id="SVGID_13_" d="M380.7,292.48c-2.18-0.48-4.31-1.05-6.45-1.73c-0.53-0.18-1.05-0.35-1.58-0.53
					c-2.12-0.75-4.18-1.58-6.23-2.53c-1.02-0.47-2.03-0.97-3.03-1.5c-1.5-0.8-2.98-1.65-4.43-2.55c-0.55-0.35-1.08-0.68-1.63-1.05
					c-0.95-0.63-1.87-1.28-2.78-1.95c-1.37-1.02-2.72-2.08-4.03-3.22c-1.32-1.13-2.58-2.32-3.81-3.56l22.37-22.37
					c14.56,14.58,38.27,14.58,52.83,0l25.94-25.94l22.39,22.39l-11.78,11.78l-14.16,14.14c-1.25,1.23-2.52,2.43-3.83,3.56
					c-1.32,1.13-2.65,2.2-4.03,3.22c-0.92,0.67-1.85,1.32-2.78,1.95c-0.55,0.37-1.08,0.7-1.63,1.05c-1.45,0.9-2.93,1.75-4.43,2.55
					c-1,0.53-2.02,1.03-3.03,1.5c-2.03,0.95-4.11,1.78-6.23,2.53c-0.52,0.18-1.05,0.35-1.58,0.53c-2.12,0.68-4.26,1.25-6.43,1.73
					C400.55,294.6,390.44,294.6,380.7,292.48z"/>
			</defs>
      <clipPath id="SVGID_14_">
				<use xlink:href="#SVGID_13_"  style="overflow:visible;"/>
			</clipPath>
      <g class="st10">
				<g>
					<defs>
						<path id="SVGID_15_" d="M380.7,292.49c-2.18-0.48-4.31-1.05-6.45-1.73c-0.53-0.18-1.05-0.35-1.58-0.53
							c-2.12-0.75-4.18-1.58-6.23-2.53c-1.02-0.47-2.03-0.97-3.03-1.5c-1.5-0.8-2.98-1.65-4.43-2.55c-0.55-0.35-1.08-0.68-1.63-1.05
							c-0.95-0.63-1.87-1.28-2.78-1.95c-1.37-1.02-2.72-2.08-4.03-3.22c-1.32-1.13-2.58-2.32-3.81-3.56l22.37-22.37
							c14.56,14.58,38.27,14.58,52.83,0l25.94-25.94l22.39,22.39l-11.78,11.78l-14.16,14.14c-1.25,1.23-2.52,2.43-3.83,3.56
							c-1.32,1.13-2.65,2.2-4.03,3.22c-0.92,0.67-1.85,1.32-2.78,1.95c-0.55,0.37-1.08,0.7-1.63,1.05c-1.45,0.9-2.93,1.75-4.43,2.55
							c-1,0.53-2.02,1.03-3.03,1.5c-2.03,0.95-4.11,1.78-6.23,2.53c-0.52,0.18-1.05,0.35-1.58,0.53c-2.12,0.68-4.26,1.25-6.43,1.73
							C400.55,294.61,390.44,294.61,380.7,292.49z"/>
					</defs>
          <clipPath id="SVGID_16_">
						<use xlink:href="#SVGID_15_"  style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_16_);">

							<image style="overflow:visible;" width="125" height="125" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAB9CAYAAACPgGwlAAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(1 0 0 1 346 198.5365)">
						</image>
					</g>
				</g>
			</g>
		</g>
    <g>
			<defs>
				<path id="SVGID_17_" d="M372.63,150.31l-11.78-11.78l-14.16-14.14c-26.96-26.95-26.96-70.65,0-97.61l22.39,22.37
					c-14.58,14.58-14.58,38.28,0,52.84l14.14,14.16l11.78,11.78L372.63,150.31z"/>
			</defs>
      <clipPath id="SVGID_18_">
				<use xlink:href="#SVGID_17_"  style="overflow:visible;"/>
			</clipPath>
      <g class="st11">
				<g>
					<defs>
						<path id="SVGID_19_" d="M372.63,150.32l-11.78-11.78l-14.16-14.14c-26.96-26.95-26.96-70.65,0-97.61l22.39,22.37
							c-14.58,14.58-14.58,38.28,0,52.84l14.14,14.16l11.78,11.78L372.63,150.32z"/>
					</defs>
          <clipPath id="SVGID_20_">
						<use xlink:href="#SVGID_19_"  style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_20_);">

							<image style="overflow:visible;" width="125" height="124" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAB8CAYAAABE3L+AAAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(1 0 0 1 297 26.5366)">
						</image>
					</g>
				</g>
			</g>
		</g>
    <g>
			<defs>
				<path id="SVGID_21_" d="M593.78,273.86h-0.02l-22.37-22.37c14.58-14.56,14.58-38.27,0-52.84l-14.16-14.14l-11.78-11.8
					l22.39-22.37l25.94,25.94c0.32,0.32,0.63,0.65,0.95,0.97c0.53,0.53,1.05,1.1,1.57,1.67c0.3,0.33,0.6,0.67,0.88,1.02
					c0.37,0.42,0.73,0.83,1.07,1.25c0.47,0.57,0.93,1.13,1.37,1.72c0.7,0.92,1.38,1.85,2.05,2.78c4.28,6.15,7.45,12.81,9.5,19.76
					c0.32,1.07,0.62,2.13,0.87,3.22C617.55,231.28,611.47,256.18,593.78,273.86z"/>
			</defs>
      <clipPath id="SVGID_22_">
				<use xlink:href="#SVGID_21_"  style="overflow:visible;"/>
			</clipPath>
      <g class="st12">
				<g>
					<defs>
						<path id="SVGID_23_" d="M593.78,273.87h-0.02l-22.37-22.37c14.58-14.56,14.58-38.27,0-52.84l-14.16-14.14l-11.78-11.8
							l22.39-22.37l25.94,25.94c0.32,0.32,0.63,0.65,0.95,0.97c0.53,0.53,1.05,1.1,1.57,1.67c0.3,0.33,0.6,0.67,0.88,1.02
							c0.37,0.42,0.73,0.83,1.07,1.25c0.47,0.57,0.93,1.13,1.37,1.72c0.7,0.92,1.38,1.85,2.05,2.78c4.28,6.15,7.45,12.81,9.5,19.76
							c0.32,1.07,0.62,2.13,0.87,3.22C617.55,231.29,611.47,256.19,593.78,273.87z"/>
					</defs>
          <clipPath id="SVGID_24_">
						<use xlink:href="#SVGID_23_"  style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_24_);">

							<image style="overflow:visible;" width="122" height="130" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAACCCAYAAACJmNyQAAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(1 0 0 1 520 146.5365)">
						</image>
					</g>
				</g>
			</g>
		</g>
    <g>
			<defs>
				<polygon id="SVGID_25_" points="492.62,225.55 470.23,203.16 557.23,116.16 579.62,138.53 579.62,138.55 567.84,150.31
					567.84,150.33 545.45,172.7 				"/>
			</defs>
      <clipPath id="SVGID_26_">
				<use xlink:href="#SVGID_25_"  style="overflow:visible;"/>
			</clipPath>
      <g class="st13">
				<g>
					<defs>
						<polygon id="SVGID_27_" points="492.62,225.55 470.23,203.16 557.23,116.17 579.62,138.54 579.62,138.56 567.84,150.32
							567.84,150.34 545.45,172.71 						"/>
					</defs>
          <clipPath id="SVGID_28_">
						<use xlink:href="#SVGID_27_"  style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_28_);">

							<image style="overflow:visible;" width="110" height="111" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAABvCAYAAAANB/VeAAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(1 0 0 1 470 115.5366)">
						</image>
					</g>
				</g>
			</g>
		</g>
    <g>
			<defs>
				<polygon id="SVGID_29_" points="417.4,150.31 470.22,203.16 492.61,225.53 492.61,225.55 504.39,237.32 482.02,259.7
					470.24,247.92 470.22,247.92 447.85,225.53 395.01,172.7 				"/>
			</defs>
      <clipPath id="SVGID_30_">
				<use xlink:href="#SVGID_29_"  style="overflow:visible;"/>
			</clipPath>
      <g class="st14">
				<g>
					<defs>
						<polygon id="SVGID_31_" points="417.4,150.32 470.22,203.16 492.61,225.54 492.61,225.55 504.39,237.33 482.02,259.71
							470.24,247.93 470.22,247.93 447.85,225.54 395.01,172.71 						"/>
					</defs>
          <clipPath id="SVGID_32_">
						<use xlink:href="#SVGID_31_"  style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_32_);">

							<image style="overflow:visible;" width="110" height="111" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAABvCAYAAAANB/VeAAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(1 0 0 1 395 149.5365)">
						</image>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
    <g id="pink">
	<path class="st15 pink" d="M236,160.54L113.5,37.04c-20.99-20.99-55.01-20.99-76,0s-20.99,55.01,0,76l26.31,26.31"/>
</g>
    <g id="green">
	<path class="st16 green" d="M161,63.54l26.51-26.25c20.99-20.99,55.01-20.99,76,0s20.99,55.01,0,76L139.65,236.75"/>
</g>
    <g id="light_blue">
	<path class="st17 light_blue" d="M63.81,139.35L187.26,263.3c20.99,20.99,55.01,20.99,76,0s20.99-55.01,0-76L236,160.54"/>
</g>
    <g id="dark_blue">
	<path class="st18 dark_blue" d="M139.65,236.75l-26.4,26.3c-20.99,20.99-55.01,20.99-76,0s-20.99-55.01,0-76L139,83.54"/>
</g>
</svg>
</div>
</div>
